import type { UnitCategory } from "verdi-common/Configurations/SensorConfigurations/SensorConfigurationTypes";

/**
 * Where a unit category's panel sits in the stack and what color its series are drawn in. A card
 * hands the generator a list of these: position is the order, and the list is the dial.
 *
 * `colors` is a list because one card can show two streams in a category — a station reports air
 * temperature outdoors and inside the gateway. The second stream takes the second color.
 */
export type UnitCategoryPresentation = {
    category: UnitCategory;
    colors?: string[];
};

/**
 * Sorts panels and streams. Categories the list leaves out all rank the same, so a stable sort
 * leaves them in the order the API sent them, below the listed ones.
 */
export function unitCategoryRank(presentation: UnitCategoryPresentation[], unitCategory: string): number {
    const index = presentation.findIndex((entry) => entry.category === unitCategory);
    return index === -1 ? presentation.length : index;
}

/**
 * @param indexInCategory - which stream this is among the ones sharing its category, so two streams
 *     in one category don't come out the same color.
 * @returns undefined past the end of the category's color list, and for a category not listed.
 */
export function unitCategoryColor(
    presentation: UnitCategoryPresentation[],
    unitCategory: string,
    indexInCategory: number,
): string | undefined {
    return presentation.find((entry) => entry.category === unitCategory)?.colors?.[indexInCategory];
}
